import nxModule from 'nxModule';
import $ from 'jquery';

const templateUrl = require('./file-upload-new.template.html');
nxModule.component('fileUploadNew', {
  templateUrl,
  bindings: {
    'onFilesAdded': '&',
    'validate': '<',
    'ngDisabled': '<',
    'multiple': '<',
    'enableWebcam': '<'
  },
  controller: function () {
    const that = this;
    that.webcamVisible = false;
    that.invalidFiles;

    const modalElement = () =>
      $('.file-upload-new__modal').find('.modal');

    that.showWebcam = e => {
      e.stopPropagation();
      e.preventDefault();
      that.webcamVisible = true;

      requestAnimationFrame(() => {
        modalElement().modal('show');
        modalElement().on('hidden', () => {
          that.webcamVisible = false;
        });
      });

    };

    that.hideWebcam = () => {
      modalElement().modal('hide');
      that.webcamVisible = false;
      that.uploadForm.$setPristine();
      that.uploadForm.$setUntouched();
    };

    that.onPhotoTaken = blob => {
      that.hideWebcam();

      blob.name = 'cameraPicture';
      that.addFiles([blob]);
    };

    that.addFiles = files => {
      that.onFilesAdded({files, });
    };
  }
});
